import type { CloudinaryVideo, SanityImage } from '@time-line/components/types';
import { VideoSplitHero } from 'components/heros/VideoSplitHero';
import type { ReactNode } from 'react';

import { ProfileImageSplit } from './ProfileImageSplit';

interface HeroProps {
  children: ReactNode;
  image?: SanityImage;
  video?: CloudinaryVideo;
  hasCta?: boolean;
}

export function HeroWrapper({ image, video, children, hasCta }: HeroProps) {
  if (video) {
    return (
      <VideoSplitHero
        video={video}
        direction="rtl"
        columnWidths={{
          content: '6 / -1',
          video: '1 / 6',
        }}
        videoMaxWidth={380}
      >
        {children}
      </VideoSplitHero>
    );
  }

  if (image) {
    return (
      <ProfileImageSplit
        image={image}
        imageMaxWidth={hasCta ? 440 : 380}
        pb={{ base: hasCta ? 'xs' : 'lg', md: 0 }}
      >
        {children}
      </ProfileImageSplit>
    );
  }

  return null;
}
